import { isFunction, isString } from '@mechhive/helpers';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { GoogleReCaptchaCheckbox } from 'react-google-recaptcha-ultimate';
import { useTranslate } from '~/hooks/useTranslate';

type RecaptchaProps = {
  invalid?: boolean;
  action?: string;
  onChange?:  ( token: string ) => void;
}

export type Recaptcha = {
  reset: () => void;
}

export const Recaptcha = forwardRef<Recaptcha, RecaptchaProps>( ( { invalid, action, onChange }: RecaptchaProps, ref ) => {
  const t = useTranslate();
  const [ count, setCount ] = useState<number>( 0 );

  const handleRecaptchaTokenChange = useCallback( ( value : string | null ) => {
    if ( isFunction( onChange ) && isString( value ) ){
      onChange( value );
    }
  }, [] );

  useImperativeHandle( ref, () => {
    return {
      reset() {
        setCount( prev => prev + 1 );
      }
    }
  }, [] );

  return (
    <div className={ 'flex flex-col items-center justify-center' }>
      <GoogleReCaptchaCheckbox
        key={ count }
        action={ action }
        onChange={ handleRecaptchaTokenChange }
        theme='dark'
      />
      { invalid === true &&
        <div className={ 'text-red-500 text-sm mt-2' }>{t( 'RECAPTCHA_ERROR_MESSAGE' )}.</div>
      }
    </div>
  )
} );

Recaptcha.displayName = 'Recaptcha';
